import { apiHost } from "../../../../consts";

import type { ActionToggleKind } from "./ActionToggle.types";

export type ActionKindConfig = {
  url: string;
  activeAction: string;
  inactiveAction: string;
  activeSymbol: string;
  inactiveSymbol: string;
  responseKey: string;
};

export const kindConfig: Record<ActionToggleKind, ActionKindConfig> = {
  delete: {
    url: `${apiHost}/solutions/api/delete/`,
    activeAction: "restore",
    inactiveAction: "remove",
    activeSymbol: "♻️",
    inactiveSymbol: "🗑️",
    responseKey: "deleted",
  },
  deleteRecursive: {
    url: `${apiHost}/solutions/api/delete/`,
    activeAction: "restore",
    inactiveAction: "remove",
    activeSymbol: "↳♻️",
    inactiveSymbol: "↳🗑️",
    responseKey: "deleted",
  },
  moderate: {
    url: `${apiHost}/solutions/api/moderate/`,
    activeAction: "unmoderate",
    inactiveAction: "moderate",
    activeSymbol: "👁️",
    inactiveSymbol: "🙈",
    responseKey: "moderated",
  },
};
